(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-countdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function pad(v) { return v < 10 ? '0' + v : String(v); }

  function initCountdown(section) {
    if (section.dataset.bcCdInit === 'true') return;
    section.dataset.bcCdInit = 'true';

    var raw = (section.dataset.launch || '').trim();
    var tzOffset = parseFloat(section.dataset.tzOffset);
    if (isNaN(tzOffset)) tzOffset = -4; /* Chile continental por defecto */

    /* Formato esperado: YYYY-MM-DD HH:MM (hora local de la tienda) */
    var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (!m) return; /* fecha inválida o vacía: no hace nada */

    /* Convertir la hora local de la tienda a UTC usando el offset configurado */
    var launchUTC = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4] - tzOffset, +m[5], 0);

    var timerEl = section.querySelector('[data-timer]');
    var expiredEl = section.querySelector('[data-expired]');
    var dEl = section.querySelector('[data-days]');
    var hEl = section.querySelector('[data-hours]');
    var mEl = section.querySelector('[data-mins]');
    var sEl = section.querySelector('[data-secs]');
    if (!timerEl || !dEl) return;

    var interval = null;

    function expire() {
      if (interval) clearInterval(interval);
      if (section.dataset.expiredBehavior === 'hide') {
        section.style.display = 'none';
        return;
      }
      timerEl.hidden = true;
      if (expiredEl) expiredEl.hidden = false;
    }

    function tick() {
      var diff = launchUTC - Date.now();
      if (diff <= 0) { expire(); return; }
      var secs = Math.floor(diff / 1000);
      var days = Math.floor(secs / 86400);
      var hours = Math.floor((secs % 86400) / 3600);
      var mins = Math.floor((secs % 3600) / 60);
      var s = secs % 60;
      dEl.textContent = pad(days);
      hEl.textContent = pad(hours);
      mEl.textContent = pad(mins);
      sEl.textContent = pad(s);
    }

    tick();
    interval = setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="bc-countdown"]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-section-type="bc-countdown"]');
    if (s) { s.dataset.bcCdInit = ''; initCountdown(s); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
